export const HOME_PATH = '/';
export const BLOG_PATH = '/blog/';
export const ABOUT_PATH = '/about/';
export const CONTACT_PATH = '/contact/';
